import { useCallback } from 'react';
import { settingsOrgFlag } from 'src/store/actions/appointment.action';
import { getCurrentPractitionerEntitlements } from 'src/store/actions/practitioner.action';
import { useDispatch } from 'react-redux';

export * from './useGetPractitionerList';
export * from './useGetPractitonerWorkspaceList';
export * from './useOnboardPractitioner';
export * from './useOnboardPractitionerToWorkspace';
export * from './useGetPracttionerDetails';
export * from './useGetSpecialtyDemoConversation';
export * from './useCompleteOnboardingDemo';
export * from './useSyncEncounterPractitioner';

export const useLegacyPractitionerStore = () => {
  const dispatch = useDispatch();

  const fetchCurrentPractitionerEntitlements = useCallback(async () => {
    await dispatch(getCurrentPractitionerEntitlements() as any);
  }, [dispatch]);

  const fetchSettingsOrgFlag = useCallback(async () => {
    await dispatch(settingsOrgFlag() as any);
  }, [dispatch]);

  return {
    fetchCurrentPractitionerEntitlements,
    fetchSettingsOrgFlag,
  };
};
